/**
 * loadCollision: load collision data by URL extension.
 *
 * .glb              -> MeshCollision (recommended for production walk mode)
 * .voxel.json       -> VoxelCollision (loads sibling .voxel.bin)
 *
 * Returns null on failure so the app can fall back to free-flight mode.
 */

import type { Application } from 'playcanvas';
import { MeshCollision, loadVoxelCollision } from '../collision';
import type { Collision } from '../collision';

export async function loadCollision(app: Application, url: string): Promise<Collision> {
    const lower = url.toLowerCase();
    if (lower.endsWith('.glb')) {
        return MeshCollision.fromGlb(app, url);
    }
    if (lower.endsWith('.voxel.json')) {
        return loadVoxelCollision(url);
    }
    throw new Error(`Unsupported collision format: ${url}`);
}
